<template>
  <div class="row">
    <div :id="[store.showLeftMenu.value ? 'lk_menu_mobile' : 'lk_menu']">
      <loading
        v-bind:active="isLoading"
        loader="bars"
        color="#e82862"
        v-bind:opacity="0.9"
        v-bind:width="100"
        v-bind:height="100"
        is-full-page
      ></loading>
      <template v-for="(item, index) in items" :key="index">
        <div
          v-if="
            item.title[store.langSelect.value] != '' &&
            ((store.currentServer == 0 && item.game == true) ||
              store.currentServer != 0)
          "
          class="lk_menu_item"
          :class="{ lk_menu_item_selected: item.selected }"
          @click="clickItem(index)"
        >
          {{ item.title[store.langSelect.value] }}
        </div>
      </template>

      <div
        style="
          width: 300px;
          height: 2px;
          border-bottom: 1px solid #d4d9dd;
          padding-top: 50px;
        "
      ></div>
      <div style="margin: 20px">
        <div class="lk_support_header">Support</div>
        <div style="display: flex; flex-direction: row; height: 40px; margin-top: 10px;">
          <div style="position: relative; width: 200px;">
            <div style="position: absolute; top: 0; left: 0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="12" fill="#E82862" />
                <path
                  d="M15.4396 19H12.108C11.1517 19 10.2931 18.8434 9.53213 18.5301C8.78149 18.2169 8.14396 17.7783 7.61954 17.2145C7.09512 16.6506 6.69409 15.9771 6.41645 15.194C6.13882 14.4004 6 13.5233 6 12.5627C6 11.602 6.14396 10.7197 6.43188 9.91566C6.71979 9.11165 7.12596 8.42249 7.65039 7.84819C8.18509 7.26345 8.82776 6.80924 9.57841 6.48554C10.3393 6.16185 11.1928 6 12.1388 6C12.982 6 13.7584 6.13052 14.4679 6.39157C15.1877 6.65261 15.8098 7.03374 16.3342 7.53494C16.8586 8.03614 17.2648 8.65743 17.5527 9.3988C17.8509 10.1297 18 10.9703 18 11.9205C18 12.5157 17.9383 13.0586 17.8149 13.5494C17.6915 14.0297 17.5064 14.4474 17.2596 14.8024C17.0231 15.147 16.7301 15.4133 16.3805 15.6012C16.0308 15.7892 15.6298 15.8831 15.1774 15.8831C14.6427 15.8831 14.2159 15.7526 13.8972 15.4916C13.5784 15.2305 13.3985 14.8807 13.3573 14.4422H13.2802C13.1465 14.8807 12.9357 15.2253 12.6478 15.4759C12.3599 15.7265 11.9692 15.8518 11.4756 15.8518C11.126 15.8518 10.8021 15.7839 10.5039 15.6482C10.2057 15.502 9.94344 15.2932 9.71722 15.0217C9.50129 14.7502 9.32648 14.4108 9.1928 14.0036C9.06941 13.5859 9.00771 13.1056 9.00771 12.5627C9.00771 12.0197 9.06941 11.5394 9.1928 11.1217C9.32648 10.704 9.50129 10.3594 9.71722 10.088C9.94344 9.81647 10.2057 9.61285 10.5039 9.47711C10.8021 9.33092 11.126 9.25783 11.4756 9.25783C11.9075 9.25783 12.2571 9.37791 12.5244 9.61807C12.8021 9.84779 12.9974 10.1297 13.1105 10.4639H13.1877V9.3988H14.6992V13.7687C14.6992 14.0715 14.7609 14.2908 14.8843 14.4265C15.0077 14.5622 15.1877 14.6301 15.4242 14.6301C15.8149 14.6301 16.1234 14.4213 16.3496 14.0036C16.5758 13.5859 16.6889 12.9647 16.6889 12.1398V11.6229C16.6889 10.9442 16.5758 10.3333 16.3496 9.79036C16.1234 9.24739 15.8046 8.78795 15.3933 8.41205C14.9923 8.03614 14.5141 7.749 13.9589 7.5506C13.4036 7.34177 12.7969 7.23735 12.1388 7.23735C11.4087 7.23735 10.7455 7.36265 10.1491 7.61325C9.56298 7.86386 9.05913 8.20843 8.63753 8.64699C8.21594 9.08554 7.89203 9.60763 7.66581 10.2133C7.43959 10.8189 7.32648 11.4819 7.32648 12.2024V12.8916C7.32648 13.612 7.43959 14.2699 7.66581 14.8651C7.89203 15.4602 8.2108 15.9719 8.62211 16.4C9.0437 16.8281 9.54756 17.157 10.1337 17.3867C10.7198 17.6269 11.3779 17.747 12.108 17.747H15.4396V19ZM11.9846 14.5518C12.3239 14.5518 12.6067 14.4422 12.8329 14.2229C13.0694 13.9932 13.1877 13.7269 13.1877 13.4241V11.5759C13.1877 11.2835 13.0746 11.0434 12.8483 10.8554C12.6221 10.657 12.3342 10.5578 11.9846 10.5578C11.5527 10.5578 11.2185 10.6936 10.982 10.9651C10.7558 11.2261 10.6427 11.5707 10.6427 11.9988V13.1108C10.6427 13.5494 10.7558 13.8992 10.982 14.1602C11.2185 14.4213 11.5527 14.5518 11.9846 14.5518Z"
                  fill="white"
                />
              </svg>
            </div>
            <div style="margin-left: 32px; margin-top: 3px">
              <a  href="mailto:support@ae.exchange" target="_blank" style="text-decoration: underline; color:#e82862;">client@ae.exchange</a>
            </div>
          </div>
          <div>
            <div style="position: relative">
              <div style="position: absolute; top: 0; left: 0">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                    fill="url(#paint0_linear_6863_69926)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_6863_69926"
                      x1="11.99"
                      y1="0"
                      x2="11.99"
                      y2="23.8102"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#2AABEE" />
                      <stop offset="1" stop-color="#229ED9" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>

              <div style="position: absolute; top: 4px; left: 3px">
                <svg
                  width="14"
                  height="11"
                  viewBox="0 0 14 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.42733 4.87011C4.92441 3.35138 7.25247 2.34222 8.4215 1.85262C11.7487 0.463781 12.4481 0.223981 12.8978 0.213989C12.9977 0.213989 13.2175 0.233973 13.3674 0.353873C13.4873 0.45379 13.5173 0.583682 13.5372 0.683598C13.5572 0.783515 13.5772 0.99334 13.5572 1.15321C13.3774 3.05162 12.598 7.65779 12.1984 9.77602C12.0285 10.6753 11.6988 10.975 11.379 11.005C10.6796 11.0649 10.1501 10.5454 9.48061 10.1057C8.4215 9.41632 7.83199 8.98668 6.80285 8.30724C5.61384 7.52789 6.3832 7.09825 7.06263 6.39884C7.24248 6.21899 10.3099 3.42132 10.3699 3.17153C10.3799 3.14155 10.3799 3.02165 10.3099 2.9617C10.24 2.90175 10.1401 2.92173 10.0601 2.94172C9.95022 2.9617 8.27162 4.08077 5.00435 6.28893C4.52474 6.61865 4.0951 6.77852 3.70543 6.76853C3.27579 6.75854 2.45647 6.52873 1.83699 6.32889C1.08761 6.08909 0.488109 5.9592 0.538068 5.53955C0.568043 5.31973 0.867793 5.09992 1.42733 4.87011Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div style="margin-left: 32px; margin-top: 3px">
                <a href="https://t.me/aeSupport_bot" target="_blank" style="text-decoration: underline; color:#e82862;">Telegram bot</a>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>

    <div id="lk_content">
      <div class="lk_header row">
        <div class="icons_fold">
          <el-icon v-if="store.showLeftMenu.value" @click="foldClick"
            ><Expand
          /></el-icon>
          <el-icon v-else @click="foldClick"><Fold /></el-icon>
        </div>
        <HeaderLk />
        <div class="exit">
          <div id="lk_exit" @click="exitLk">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.333 1H18.7775C19.3668 1 19.9321 1.23413 20.3488 1.65087C20.7655 2.06762 20.9997 2.63285 20.9997 3.22222V18.7778C20.9997 19.3671 20.7655 19.9324 20.3488 20.3491C19.9321 20.7659 19.3668 21 18.7775 21H14.333"
                stroke="#222222"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.77734 16.5556L14.3329 11L8.77734 5.44446"
                stroke="#222222"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.3333 11H1"
                stroke="#222222"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      <div id="cetificate" v-show="items[0].selected">

        <div v-show="certificateCreate">
          <div class="lk_content_title">
            {{ messages.certificateH[store.langSelect.value] }}
          </div>
          <div style="margin-top: 40px; margin-left: 0">
          <!--  <div
              style="width: 465px; margin-bottom: 20px; position: relative"
              class="lk_content_info_block"
            >
              <div style="display: table-cell; width: 70px">
                <el-icon
                  style="
                    font-size: 50px;
                    position: absolute;
                    transform: rotate(180deg);
                    left: 20px;
                    color: #e82862;
                  "
                  ><Warning
                /></el-icon>
              </div>
              <div style="display: table-cell">
                {{ messages.aeinfo[store.langSelect.value] }}
              </div>
            </div> -->

              <div
        style="width: 465px; margin-bottom: 40px; height: 48px; position: relative"
        class="lk_content_info_block"
      >
        <div style="display: table-cell; width: 70px">
          <el-icon
            style="
              font-size: 50px;
              position: absolute;
              transform: rotate(180deg);
              left: 20px;
              color: #e82862;
            "
          >
            <Warning />
          </el-icon>
        </div>
        <div style="display: table-cell" class="lk_content_info_block_ul">
               {{ messages.certificateCreateInfo[store.langSelect.value] }}
              </div>
              </div>
              

            <div>
              <input
                :placeholder="
                  messages.certificatePasswordP[store.langSelect.value]
                "
                v-model="passCert"
                :class="[
                  !passClass
                    ? 'lk_content_form_input'
                    : 'lk_content_form_input_error',
                ]"
                :disabled="!сheckMoneyInAccounts"
              />
            </div>
            <div>
              <input
                :placeholder="
                  messages.certificatePasswordPC[store.langSelect.value]
                "
                v-model="passCertConfirm"
                :class="[
                  !passConfirmClass
                    ? 'lk_content_form_input'
                    : 'lk_content_form_input_error',
                ]"
                :disabled="!сheckMoneyInAccounts"
              />
            </div>
            <Button
              :text="messages.certificateCreateB[store.langSelect.value]"
              @click="ShowCertificateCodeDialog"
              :disabled="!сheckMoneyInAccounts"
            />
          </div>
        </div>
        <div v-show="certificateLoad">
          <div class="lk_content_title">
            {{ messages.certificateCreatedT[store.langSelect.value] }}
          </div>
          <Button
            :link="linkhref"
            :download="store.serverConf[store.currentServer].name + '.pem'"
            :text="messages.certificateCreatedB[store.langSelect.value]"
            style="margin-top: 60px"
          />
          <Button
            :text="messages.certificateCreateNewB[store.langSelect.value]"
            @click="ClearCertificate"
            style="margin-top: 30px"
          />
        </div>
        <Button
          :link="
            store.ServerUrl +
            '/up/ae/' +
            store.serverConf[store.currentServer].desktopterminalfilename
          "
          :text="messages.downloadTerminal[store.langSelect.value]"
          acolor="#f7f7f7"
          style="margin-top: 30px"
        />
      </div>
      <div id="android_terminal" v-show="items[1].selected">
        <AndroidComponent />
      </div>
      <div id="web_terminal"></div>
      <div id="accounts" v-show="items[3].selected">
               <!--   <div class="row">
          <Button
            :text="messages.addAccountBtnText[store.langSelect.value]"
            @click="AddAccount"
          ></Button>
          <template v-if="baseAcc.length > 1" >
            <span style="margin-left: 15px; width:80px;margin-top: 6px;"> к счёту</span>
            <el-select
              v-model="selAcc"
              icon-сlass="caret-top"
              style="margin-left: 5px; width: 150px;"
            >
              <el-option
                v-for="(item, i) in baseAcc"
                :key="i"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </template>
          <span id="addAccountErr"> {{ addAccountErr }}</span>
        </div>  -->
        <template v-for="acc in accounts" :key="acc.Account">
          <AccountInfo :account="acc.Account"></AccountInfo>
        </template>
      </div>

      <div id="serviceForAE" v-show="items[5].selected">
        <ServicesForAE
          v-if="items[5].selected && store.langSelect.value == 0"
          :ac-name="acName"
        ></ServicesForAE>
        <ServicesForAEEng
          v-if="items[5].selected && store.langSelect.value == 1"
          :ac-name="acName"
        ></ServicesForAEEng>
      </div>
      <div id="funds" v-show="items[6].selected">
        <Funds
          v-if="items[6].selected && store.langSelect.value == 0"
          :ac-name="acName"
        ></Funds>
        <FundsEng
          v-if="items[6].selected && store.langSelect.value == 1"
          :ac-name="acName"
        ></FundsEng>
      </div>
      <div id="referral" v-show="items[9].selected">
        <div class="lk_content_title">
          {{ messages.referralH[store.langSelect.value] }}
        </div>
        <div style="margin-top: 40px">
          <ReferralComponent v-if="items[9].selected"></ReferralComponent>
        </div>
      </div>
      <div id="TradingMeans" v-show="items[4].selected">
        <TradingMeans v-if="items[4].selected"></TradingMeans>
      </div>
      <div id="levels" v-show="items[7].selected">
        <Levels v-if="items[7].selected" @view-levels="viewLevels"></Levels>
      </div>
      <div id="referral" v-show="items[8].selected">
        <div style="margin-top: 40px">
          <ClubComponent v-if="items[8].selected"></ClubComponent>
        </div>
      </div>
      <div id="blog" v-show="items[10].selected">
        <div style="margin-top: 40px">
          <BlogToastComponent v-if="items[10].selected"></BlogToastComponent>
        </div>
      </div>
      <div id="api" v-show="items[11].selected">
        <div style="margin-top: 40px">
          <APIComponent v-if="items[11].selected"></APIComponent>
        </div>
      </div>
  <!--    <div id="blogToast" v-show="items[12].selected">
        <div style="margin-top: 40px">
          <BlogToastComponent v-if="items[12].selected"></BlogToastComponent>
        </div>
      </div> -->
    </div>

    <CheckCode
      :show="ShowCheck"
      :checkedfn="createCertificate"
      @closedialog="CloseCodeDialog"
    ></CheckCode>
  </div>
</template>
<script>
import axios from "axios";
//import Loading from "vue-loading-overlay";
// Import stylesheet
//import "vue-loading-overlay/dist/vue-loading.css";
//import Centrifuge from "centrifuge";
import HeaderLk from "@/components/HeaderLogin";
import SampleQrImage from "@/assets/sampleqr.png";
import { useMyStorage } from "@/store/global";
import { useRouter } from "vue-router";
import { reactive, ref, watch } from "vue";
import Button from "@/components/Button";
import Loading from "@/components/Vld";
import AccountInfo from "@/components/AccountInfo";
import CheckCode from "@/components/CheckCode";
import ServicesForAE from "@/components/ServicesForAE";
import ServicesForAEEng from "@/components/ServicesForAEEng";
import Funds from "@/components/Funds";
import FundsEng from "@/components/FundsEng";
import Levels from "@/components/Levels";
import AndroidComponent from "./Android.vue";

//import BlogComponent from "./Blog.vue";
import BlogToastComponent from "./BlogToast.vue"
import ReferralComponent from "./Referral";
import APIComponent from "./API.vue";
import TradingMeans from "./TradingMeans";
import ClubComponent from "./Club";
import {  Expand, Fold, Warning } from "@element-plus/icons-vue";

export default {
  components: {
    Levels,
    Button,
    Loading,
    AccountInfo,
    ServicesForAE,
    Funds,
    FundsEng,
    CheckCode,
    ReferralComponent,
    TradingMeans,
    ServicesForAEEng,
    ClubComponent,
    HeaderLk,
    Expand,
    Fold,
    Warning,
  //  BlogComponent,
    BlogToastComponent,
    AndroidComponent,
    APIComponent,
  },
  setup() {
    const router = useRouter();
    const store = useMyStorage();
    const ShowCheck = ref(false);
    const сheckMoneyInAccounts=ref(false)
    const addAccountErr = ref("");
    const accounts = ref(store.accounts);
    const selAcc = ref("");
    const baseAcc = ref([]);
    const items = reactive([
      {
        title: ["десктоп терминал", "desktop terminal"],
        el_id: "certificate",
        selected: false,
        game: true,
      },
      {
        title: ["android терминал", "android terminal"],
        el_id: "android_terminal",
        selected: false,
        game: true,
      },
      {
        title: ["веб терминал", "web terminal"],
        el_id: "web_terminal",
        selected: false,
        url: "https://trade.ae.exchange",
        blank: true,
        game: false,
      },
      {
        title: ["Торговые счета", "TRADING ACCOUNTS"],
        el_id: "accounts",
        selected: true,
        game: true,
      },
      {
        title: ["Финансы", "FINANCE"],
        el_id: "TradingMeans",
        selected: false,
        game: true,
      },

      {
        title: ["Стратегии", "Strateges"],
        el_id: "serviceForAE",
        selected: false,
        game: true,
      },
      {
        title: ["Фонды", "Funds"],
        el_id: "serviceForAE",
        selected: false,
        game: true,
      },
      {
        title: ["Обучение", ""],
        el_id: "levels",
        selected: false,
        game: true,
      },
      {
        title: ["Клуб", ""],
        el_id: "club",
        selected: false,
        game: true,
      },
      {
        title: ["Партнёр", "Partner"],
        el_id: "referral",
        selected: false,
        game: true,
      },
      {
        title: ["Блог", ""],
        el_id: "blog",
        selected: false,
        game: true,
      },
      {
        title: ["API", ""],
        el_id: "api",
        selected: false,
        game: true,
      },
 /*     {
        title: ["Блог New", ""],
        el_id: "blogToast",
        selected: false,
        game: true,
      },*/
    ]);
    const clickItem = (index) => {
      //const self = this;
      console.log(index);
      if (items[index].url !== undefined) {
        if (items[index].blank === true) {
          window.open(items[index].url);
        } else {
          window.location.href = self.items[index].url;
        }
        return;
      }
      items.forEach(function (val, ind) {
        items[ind].selected = false;
      });
      items[index].selected = true;
      store.showLeftMenu.value = false;
    };
    const viewLevels = () => {
      console.log("viewLevels");
      acName.value = "levels";
      clickItem(4);
    };
    if (!store.loginStatus.value) {
      store.logout();
    }
    const messages = {
      certificateH: [
        "Создание ключа для торгового терминала",
        "Generate a key for a trading terminal",
      ],
      certificateCreateInfo:[
        "Ключ к десктоп терминалу предоставляется при размере активов аккаунта в эквиваленте не менее 100 USDT.",
        "The desktop terminal key is provided when the account assets are at least 100 USDT."
      ],
      certificatePasswordP: [
        "Желаемый пароль к терминалу (минимум 6 знаков)",
        "Password for the terminal (at least 6 characters)",
      ],
      certificatePasswordPC: ["Повторите пароль", "Confirm password"],
      downloadTerminal: [
        "Скачать торговый терминал",
        "Download trading terminal",
      ],
      certificateCreateB: ["Создать", "Generate"],
      certificateCreatedT: [
        "Файл сертификата успешно создан",
        "Certificate file created successfully",
      ],
      certificateCreatedB: ["Скачать сертификат", "Download certificate"],
      certificateCreateNewB: [
        "Создать новый сертификат",
        "Generate new certificate",
      ],
      topupH: ["Пополнить счет", "Top up account"],
      topupS: ["Выберите счет", "Select account"],
      topupNot: [
        "Не доступно в Game контуре биржи",
        "Not available in the Game",
      ],
      topupHistoryH: ["История депозита", "Deposit history"],
      topupHistoryD: ["Дата", "Date"],
      topupHistorySum: ["Сумма", "Sum"],
      topupHistoryC: ["Сумма", "Confirm"],
      topupHistoryS: ["Статус", "Status"],
      topupCreateAddrB: ["Создать новый адрес", "Create new address"],
      refreshB: ["Обновить", "Refresh"],
      withdrawalT: [
        "Заявка, поданная до 14:00 UTC, обрабатывается до конца дня. По заявке поданной после 14:00 UTC вывод средств производится на следующий день. AE не начисляет собственные комиссии за вывод средств",
        "Applications submitted before 14:00 UTC are processed by the end of the day. For applications submitted after 14:00 UTC, the withdrawal of funds is made the next day. AE does not charge its own withdrawal fees\n",
      ],
      withdrawalH: ["Заявка на вывод средств", "Withdrawal request"],
      withdrawalSel: ["Выберите счет", "Select account"],
      withdrawalSum: ["Сумма выводимых BTC", "The amount of BTC withdrawn"],
      withdrawalAddr: ["Адрес", "Address"],
      withdrawalB: ["Отправить", "Send"],
      clubH: ["Клуб Опцион LAFT", ""],
      conversionH: ["Конвертация", "Exchange"],
      testsH: ["Тесты", ""],
      aeinfo: [
        "Оплата биржевой комиссии производится собственным токеном АЕ. Для проведения торговых операций требуется наличие на торговом счете клиента токена АЕ." +
          "Токен АЕ можно купить через биржевой стакан подав ордер на покупку, после совершения трейда в позициях по торговому счету появится токен АЕ.",
        "Payment for the exchange commission is made with our own AE token. To conduct trading operations, it is required to have an AE token on the client's trading account." +
          "The AE token can be bought through the order book by submitting a buy order; after the trade is completed, the AE token will appear in the positions on the trading account.",
      ],
      safetyregulationsH: ["Основные правила безопасности", ""],
      emailTitle: ["Наш ", ""],
      referralH: ["Партнёрская программа", "Affiliate program"],
      addAccountBtnText: ["Добавить счёт", "Add account"],
      addAccountErrMax: [
        "Максимальное количество счетов",
        "Maximum number of accounts",
      ],
    };
    if (accounts.value === "") {
      window.location.href = store.WebUrl + "#/login";
      //  location.reload();
    }
    if (accounts.value !== undefined) {
      if (store.accounts.value !== undefined) {
        console.log(store.accounts.value);
        accounts.value = store.accounts.value.sort((a, b) =>
          a.Account > b.Account ? 1 : b.Account > a.Account ? -1 : 0
        );
        accounts.value.forEach((v) => {
          if (!v.Account.includes("_")) {
            baseAcc.value.push(v.Account);
          }
        });
      }
    }
    watch(
      () => store.user,
      (u) => {
        if (u !== undefined) {
          accounts.value = store.accounts.value.sort((a, b) =>
            a.Account > b.Account ? 1 : b.Account > a.Account ? -1 : 0
          );
        }
      },
      { deep: true }
    );
    watch(
      ()=>store.AccountsFullData,
      ()=>{

          CheckMoneyInAccounts()
        
        
      }
    )
    const CheckMoneyInAccounts=()=>{
      const i= store.AccountsFullData
      console.log(i.value)
      if(i!==undefined ){
      let fullMoney=0
        if(i!=undefined){
          for (var key in i){
            const ii=i[key]
            fullMoney=fullMoney+ii.Money
          }
        }
        if(fullMoney>99){ //Проверка на наличие минимум 100 usdt на счетах
          сheckMoneyInAccounts.value=true
        } else {
          сheckMoneyInAccounts.value=false
        }
      } else {
        сheckMoneyInAccounts.value=false
      }
    }
    selAcc.value = accounts.value[0].Account;
    const AddAccount = () => {
      if (selAcc.value === "") return;
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + store.token.value;
      axios
        .post(store.ServerUrl + "/users/addSubAccount", {
          Account: selAcc.value,
        })
        .then(function (response) {
          console.log(response);
          if (response.data.code === 0) {
            store.GetFullUserInfo();
            addAccountErr.value = response.data.msg;
          } else {
            addAccountErr.value = "Ошибка:" + response.data.msg;
            if (response.data.msg === "Max Accounts") {
              addAccountErr.value =
                messages.addAccountErrMax[store.langSelect.value];
            }
          }
        });
    };
    const CloseCodeDialog = () => {
      // console.log("emit")
      ShowCheck.value = false;
    };
    const acName = ref("");
    const passCert = ref("");
    const passCertConfirm = ref("");
    const passClass = ref(false);
    const passConfirmClass = ref(false);
    const isLoading = ref(false);
    const certificateCreate = ref(true);
    const certificateLoad = ref(false);
    const linkhref = ref("");
    const regex = /"/i;
    const createCertificate = async () => {
      passClass.value = false;
      if (passCert.value.length < 6) {
        passClass.value = true;
        return;
      } else {
        passClass.value = false;
      }
      const v = regex.test(passCert.value);
      if (v === true) {
        passClass.value = true;
        return;
      }
      if (passCert.value !== passCertConfirm.value) {
        passConfirmClass.value = true;
        return;
      } else {
        passConfirmClass.value = false;
      }
      if (passCert.value !== "" && passCert.value === passCert.value) {
        const data = {
          // login: this.$auth.user.login,
          // email: this.$auth.user.iss,
          passCert: passCert.value,
        };
        isLoading.value = true;
        try {
          // let token = this.$auth.strategy.token.get();
          // console.log(token);
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + store.token.value;
          let response = await axios.post(
            store.ServerUrl + "/users/createCertificate",
            data
          );
          isLoading.value = false;
          if (response.data.code === 0) {
            linkhref.value = window.URL.createObjectURL(
              new Blob([response.data.data.certificate])
            );
            certificateCreate.value = false;
            certificateLoad.value = true;
            //  console.log(response.data.data.certificate)
          }
          //  console.log(response);
        } catch (err) {
          console.log(err);
        }
      }
    };
    const ClearCertificate = () => {
      passCert.value = "";
      passCertConfirm.value = "";
      passClass.value = false;
      passConfirmClass.value = false;
      certificateCreate.value = true;
      isLoading.value = false;
      ShowCheck.value = false;
      certificateLoad.value = false;
    };
    const ShowCertificateCodeDialog = () => {
      passClass.value = false;
      if (passCert.value.length < 6) {
        passClass.value = true;
        return;
      } else {
        passClass.value = false;
      }
      const v = regex.test(passCert.value);
      if (v === true) {
        passClass.value = true;
        return;
      }
      if (passCert.value !== passCertConfirm.value) {
        passConfirmClass.value = true;
        return;
      } else {
        passConfirmClass.value = false;
      }
      if (passCert.value !== "" && passCert.value === passCert.value) {
        ShowCheck.value = true;
      }
    };
    const user = store.user.value;
    const exitLk = () => {
      console.log(store);
      // await this.$auth.logout(/* .... */);
      store.logout();
    };
    const foldClick = () => {
      // await this.$auth.logout(/* .... */);
      console.log(store.showLeftMenu.value);
      store.showLeftMenu.value = !store.showLeftMenu.value;
    };
    CheckMoneyInAccounts()
    return {
      router,
      store,
      user,
      messages,
      ShowCheck,
      CloseCodeDialog,
      ShowCertificateCodeDialog,
      ClearCertificate,
      createCertificate,
      passClass,
      passCert,
      passConfirmClass,
      passCertConfirm,
      isLoading,
      certificateCreate,
      certificateLoad,
      linkhref,
      viewLevels,
      clickItem,
      acName,
      items,
      exitLk,
      foldClick,
      AddAccount,
      addAccountErr,
      accounts,
      baseAcc,
      selAcc,
      сheckMoneyInAccounts
    };
  },
  data() {
    return {
      requestSended: false,
      minConfirm: 3,
      privat: "",
      centrifuge: null,
      // accounts: [],
      subs: new Map(),
      bit: new Map(),
      bitTrans: new Map(),
      transactions: [],
      qrcodeImage: SampleQrImage,
      bitAddr: "Не доступно в данной версии",
      money: 0.0,
      gm: 0.0,
      moneyfree: 0,
    };
  },
  created: function () {
    if (!this.store.loginStatus.value) {
      this.store.logout();
    } else {
      //   console.log(this.store.user.value)
      this.initCentrifugo();
      this.bitAddr = this.messages.topupNot[this.store.langSelect.value];
    }
  },
  watch: {
    selectedaccount: function (newV) {
      //   let png = this.bit.get(newV).Png;
      //console.log(png)
      //   this.qrcodeImage = "data:image/jpeg;base64," + png;
      //   this.bitAddr = this.bit.get(newV).Addr;
      this.transactions = this.bitTrans.get(newV);
      // console.log(this.transactions);
      this.getAccount();
    },
  },
  methods: {
    getAccount() {
      const self = this;
      let acc = this.accounts.find(function (elem) {
        if (elem.Account == self.selectedaccount) {
          return elem;
        }
        return false;
      });
      if (acc) {
        self.money = acc.Money;
        self.gm = acc.GM;
        self.moneyfree = acc.MoneyFree;
      }
    },

    /* async getUserInfo() {
      try {
        axios.defaults.headers.common[
          "Authorization"
        ] = this.$auth.strategy.token.get();
        console.log(this.$auth.strategy.token.get());
        let response = await axios.get("/users/user");
        this.accounts = response.data.data;
        this.initCentrifugo();
        this.isLoading = false;
      } catch (err) {
        console.log(err);
      }
    },*/

    initCentrifugo() {
      // console.log("init cent");
      // console.log(this.$auth.user);
      //   const self = this;
      //  this.accounts = this.user.Accounts;
      //console.log(this.accounts)
      if (this.user.SessionID == "") {
        this.store.logout();
        return;
      }
      //   let centri = this.store.centrifuge.value;
      //  for (var i = 0; i < this.accounts.length; i++) {
      /*  const sub = centri.subscribe(
            this.privat +
            "bit:" +
            this.user.SessionID +
            "-" +
            this.accounts[i].Account,
            {
              publish: function (message) {
                if (message.info.user == "bit") {
                  self.bit.set(message.data.Acc, message.data);
                  if (self.selectedaccount != "") {
                    // let png = self.bit.get(self.selectedaccount).Png;
                    //  self.qrcodeImage = "data:image/jpeg;base64," + png;
                    //   self.bitAddr = self.bit.get(self.selectedaccount).Addr;
                    // console.log(self.bitAddr);
                  }
                }
              },

            }
        );
        //sub.on("publish", self.centrifigePublish);
        const subInfo = {
          sub: sub,
          account: this.accounts[i].Account,
        };
        this.subs.set(subInfo.account);*/
      //   const subT = centri.subscribe(
      /*   centri.subscribe(
          this.privat +
            "bit:" +
            this.user.SessionID +
            "-Transactions-" +
            this.accounts[i].Account,
          {
            publish: function (message) {
              if (message.info.user == "bit") {
                self.bitTrans.set(message.data.Acc, message.data.Transactions);
                if (message.data.Acc == self.selectedaccount) {
                  self.transactions = message.data.Transactions;
                }
                // console.log(message);
              }
            },
          }
        );*/
      /*      const subInfoT = {
                sub: sub,
                account: this.accounts[i].Account,
              };*/
      // }
    },
    /*  centrifigePublish(message) {
        // console.log(message);
      },*/
    getNewAddr() {
      const ch = this.selectedaccount;
      this.centrifuge.publish(
        this.privat + "bit:" + this.user.SessionID + "-" + ch,
        {
          type: "new",
        }
      );
    },
    getTrans() {
      const ch = this.selectedaccount;
      this.centrifuge.publish(
        this.privat + "bit:" + this.user.SessionID + "-Transactions-" + ch,
        {
          type: "new",
        }
      );
    },
    getTransDate(val) {
      let ts = new Date(val * 1000);
      return (
        this.pad(ts.getDate()) +
        "/" +
        this.pad(ts.getMonth() + 1) +
        "/" +
        ts.getFullYear() +
        " " +
        this.pad(ts.getHours()) +
        ":" +
        this.pad(ts.getMinutes())
      );
    },
    pad(n) {
      return n < 10 ? "0" + n : n;
    },
    getTransStatus(val) {
      if (val > this.minConfirm) {
        return "Success";
      }
      return "";
    },
    getTransConfirmations(val) {
      if (val > this.minConfirm) {
        return "Processed";
      }
      return val;
    },
  },
};
</script>
<style lang="scss">
@media (max-width: 1550px) {
  .icons_fold {
    display: block !important;
  }
  #lk_menu {
    display: none !important;
  }
  #lk_content {
    margin-left: auto !important;
  }
}
@media (max-width: 1170px) {
  #footer_lk_left {
    display: none !important;
  }
}
#addAccountErr {
  color: #e82862;
  font-size: 120%;
  padding: 10px;
}
#lk_menu_mobile,
#lk_menu {
  padding-top: 70px;
  background-color: #f7f7f7;
  width: 400px;
  .lk_menu_item {
    margin-left: 100px;
    padding: 22px 0 20px 20px;
    font-family: Proxima Nova Condensed;
    font-style: normal;
    /*font-weight: 600;*/
    font-size: 17px;
    line-height: 21px;
    /* identical to box height */
    text-transform: uppercase;
    cursor: pointer;
    color: #222222;
  }

  .lk_menu_item_selected {
    background-color: white;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml;utf8,<svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12 0H0V12L12 0Z' fill='%23E82862'/></svg>");
  }
}

#lk_content {
  margin-left: 100px;
  margin-right: auto;
  width: 980px;
  /* border: 1px solid red;*/
}

.lk_content_title {
  font-family: Proxima Nova Extrabold;
  font-style: normal;
  /*font-weight: 800;*/
  font-size: 32px;
  line-height: 39px;
  /* identical to box height */

  color: #222222;
}

.lk_content_info_block {
  border: 1px solid #f8ebeb;
  border-radius: 10px;
  padding: 12px 20px;
  display: table;
  table-layout: fixed;
  position: relative;
}

#accountselector {
  border: 1px solid #c4c4c4;
  padding: 12px 20px;
  width: 505px;
  margin-bottom: 20px;
  background-image: none;
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
  /* identical to box height */

  /* color: #a5a5a5;*/
}

.lk_content_form_input {
  border: 1px solid #c4c4c4;
  padding: 12px 20px;
  height: 20px;
  width: 465px;
  margin-bottom: 20px;
  background-image: none;
  /* border: none;
   Пароль */
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
  /* identical to box height */

  /* color: #a5a5a5;*/
}

.lk_content_form_input:focus {
  border: 1px solid #222;
  background-image: none;
  outline: none;
}

.lk_content_form_input_error {
  border: 1px solid #c4c4c4;
  padding: 12px 20px;
  height: 20px;
  width: 465px;
  margin-bottom: 20px;
  background-image: none;
  /* border: none;
   Пароль */
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
  /* identical to box height */

  /* color: #a5a5a5;*/
  border: 1px solid #e82862;
  background-image: none;
  outline: none;
}

.qrImage {
  max-width: 175px;
  max-height: 175px;
}

#bittransactions {
  border: 1px solid #c4c4c4;
  width: 100%;
  text-align: center;
}

#bittransactions tr {
  border: 1px solid #c4c4c4;
}

#bittransactions th,
#bittransactions td {
  border-right: 1px solid #c4c4c4;

  padding: 13px 5px;
}

#bittransactions th:last-child,
#bittransactions td:last-child {
  border-right: none;
}

#bittransactions td {
  border-top: 1px solid #c4c4c4;
}
.lk_header {
  margin-top: -45px;
  height: 120px;
  .exit {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    #lk_exit {
      cursor: pointer;
      margin-top: 71px;
      justify-content: flex-end;
    }
  }
  .icons_fold {
    display: none;
    width: 50px;
    margin-top: 68px;
    font-size: 32px;
  }
}
.lk_support_header {
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  line-height: 21px;
}
</style>
